import React, { useMemo } from 'react';
import useTheme from 'branding/theme';
import { useFormContext } from 'react-hook-form';
import useComponentMargin from '../../hooks/useComponentMargin';
import LabeledFieldset from '../LabeledFieldset';
import InputError from '../InputError';
import CaretIcon from '../../icons/utility/CaretIcon';
import AlertIcon from '../../icons/utility/AlertIcon';
const ListBase = ({ type, children, name, displayName, required, disabled, isToggled, isFocused, noExtraMargin, styles, errorId, errorMessage }) => {
    const isSelect = type === 'select';
    const { formState: { errors } } = useFormContext();
    const { borders, colors, inputs: { selectStyles: { wrapper }, disabled: disabledStyles, utilityIconStyles } } = useTheme();
    const marginStyles = useComponentMargin({
        marginVertical: 'small',
        ...(!errorId && { marginBottom: 'regular' })
    });
    const wrapperStyles = {
        ...wrapper,
        ...(disabled && disabledStyles),
        ...(!isFocused && !isToggled && borders.variant.secondary),
        ...(isFocused && isToggled && { backgroundColor: colors.neutrals.background }),
        // error styles MUST come after active styles to override them
        ...(!!errorId && borders.error),
        ...marginStyles,
        ...styles
    };
    const caretStyles = useMemo(() => ({
        ...utilityIconStyles,
        top: '1.2rem',
        pointerEvents: 'none',
        zIndex: 1
    }), [utilityIconStyles]);
    const alertStyles = useMemo(() => ({
        ...utilityIconStyles,
        ...(isSelect && { right: '6rem' }),
        top: '1.2rem',
        pointerEvents: 'none'
    }), [utilityIconStyles, isSelect]);
    return (React.createElement(LabeledFieldset, { displayName: displayName, name: name, required: required, disabled: disabled, hasErrors: !!errors, noExtraMargin: noExtraMargin, noBorders: true },
        React.createElement("div", { style: wrapperStyles, "data-testid": "listbase" },
            children,
            isSelect && (React.createElement(CaretIcon, { size: "utility", direction: isToggled ? 'up' : 'down', styles: caretStyles })),
            errorId && React.createElement(AlertIcon, { size: "utility", styles: alertStyles })),
        errorMessage && React.createElement(InputError, { id: errorId }, errorMessage)));
};
export default ListBase;
//# sourceMappingURL=index.js.map